// Team Block JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Team member data will be available globally
    if (typeof window.teamMembersData !== 'undefined') {
        window.teamMembers = window.teamMembersData;
    }
    
    // Initialize team pagination
    initTeamPagination();
    
    // Add event listeners to read more buttons
    const readMoreButtons = document.querySelectorAll('.team-card__read-more');
    
    readMoreButtons.forEach((button, index) => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const memberIndex = parseInt(this.getAttribute('data-member-index') || index);
            
            // Use the global function
            if (typeof window.openTeamModal === 'function') {
                window.openTeamModal(memberIndex);
            }
        });
    });
    
    // Add escape key listener
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (typeof window.closeTeamModal === 'function') {
                window.closeTeamModal();
            }
        }
    });
    
    // Add click outside modal listener
    document.addEventListener('click', function(e) {
        const modal = document.getElementById('teamModal');
        if (modal && modal.classList.contains('active')) {
            if (e.target === modal || e.target.classList.contains('team-modal__overlay')) {
                if (typeof window.closeTeamModal === 'function') {
                    window.closeTeamModal();
                }
            }
        }
    });
});

// Team Pagination Functions
function initTeamPagination() {
    const teamBlock = document.querySelector('.team-block');
    if (!teamBlock) return;
    
    const showDesktop = parseInt(teamBlock.getAttribute('data-show-desktop')) || 12;
    const showMobile = parseInt(teamBlock.getAttribute('data-show-mobile')) || 6;
    const totalMembers = parseInt(teamBlock.getAttribute('data-total-members')) || 0;
    
    const teamCards = document.querySelectorAll('.team-card');
    const showMoreBtn = document.getElementById('teamShowMoreBtn');
    
    if (!showMoreBtn || teamCards.length === 0) return;
    
    let currentVisible = 0;
    let isMobile = window.innerWidth <= 768;
    
    // Function to get current limit based on screen size
    function getCurrentLimit() {
        return isMobile ? showMobile : showDesktop;
    }
    
    // Function to show/hide cards
    function updateCardVisibility() {
        const limit = getCurrentLimit();
        
        teamCards.forEach((card, index) => {
            if (index < currentVisible) {
                card.style.display = 'flex';
                card.classList.add('visible');
            } else {
                card.style.display = 'none';
                card.classList.remove('visible');
            }
        });
        
        // Show/hide Show More button
        if (currentVisible >= totalMembers) {
            showMoreBtn.style.display = 'none';
        } else {
            showMoreBtn.style.display = 'block';
        }
    }
    
    // Function to show more cards
    function showMore() {
        const limit = getCurrentLimit();
        const increment = limit; // Show the same amount as initial load
        
        currentVisible = Math.min(currentVisible + increment, totalMembers);
        updateCardVisibility();
    }
    
    // Initialize visibility
    function initVisibility() {
        isMobile = window.innerWidth <= 768;
        currentVisible = getCurrentLimit();
        updateCardVisibility();
    }
    
    // Event listeners
    showMoreBtn.addEventListener('click', showMore);
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const wasMobile = isMobile;
            isMobile = window.innerWidth <= 768;
            
            // Only reinitialize if mobile/desktop state changed
            if (wasMobile !== isMobile) {
                initVisibility();
            }
        }, 250);
    });
    
    // Initial setup
    initVisibility();
}

// Functions are now defined inline in the PHP template to avoid timing issues
